var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":"","align":"center"}},[_vm._t("title",function(){return [_c('div',{staticClass:"py-0 px-0 pt-md-4 pb-md-6 px-md-0 text-h6"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]}),_c('v-spacer'),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }